export default "__VITE_ASSET__Dl9Khf8t__"